import * as Immutable from "immutable";
import DataLakeWidgetConfig from "data-lake/logic/DataLakeWidgetConfig";
import DataLakeWidget from "data-lake/logic/DataLakeWidget";
import { PAGE_SIZE, WIDGET_DEFAULTS, INTERNAL_DATA_LAKE_SEARCH_TYPE } from "data-lake/preview/Constants";
const defaultWidgetConfig = new DataLakeWidgetConfig(
  void 0,
  Immutable.OrderedSet(WIDGET_DEFAULTS.fields),
  PAGE_SIZE,
  WIDGET_DEFAULTS.sort,
  WIDGET_DEFAULTS.tieBreaker,
  WIDGET_DEFAULTS.fieldsOperator,
  Immutable.List()
);
export const defaultWidget = DataLakeWidget.builder().id(WIDGET_DEFAULTS.id).config(defaultWidgetConfig).build();
const isDataLakeSearchType = (searchType) => searchType.type === INTERNAL_DATA_LAKE_SEARCH_TYPE;
const createFromSearchType = (searchType) => {
  const { filters_operator, field_filters, search_after, fields } = searchType;
  return DataLakeWidgetConfig.fromJSON({
    fields,
    size: WIDGET_DEFAULTS.size,
    sort: WIDGET_DEFAULTS.sort,
    tie_breaker: WIDGET_DEFAULTS.tieBreaker,
    filters_operator,
    field_filters,
    after: search_after
  });
};
const createInitialWidget = (previousSearch) => {
  var _a, _b;
  if (!previousSearch) {
    return defaultWidget;
  }
  const query = previousSearch.queries.first();
  const searchType = query.searchTypes[0];
  if (!searchType || !isDataLakeSearchType(searchType)) {
    return defaultWidget;
  }
  return defaultWidget.toBuilder().config(createFromSearchType(searchType)).streams((_a = searchType.streams) != null ? _a : defaultWidget.streams).timerange((_b = query.timerange) != null ? _b : defaultWidget.timerange).build();
};
export default createInitialWidget;
